import type { AppCardVariantStyles } from "../appCard.variantTypes";

export const defaultStyles: AppCardVariantStyles = {
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  root: {
    padding: 24,
    borderRadius: 24,
    borderColor: "var(--fx-surface-border, #E2E8F0)",
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    hover: {
      boxShadow: "-6px 6px 10px 0px rgba(0, 0, 0, 0.10)",
      transform: "translateY(-2px)",
      borderColor: "var(--fx-surface-borderstrong, #CBD5E1)",
    },
  },
  icon: { size: 56, bg: "#f3f4f6" },
  title: { fontSize: "1rem", color: "var(--fx-surface-text, #0F172A)" },
  description: { fontSize: "0.875rem", color: "var(--fx-surface-textsecondary, #64748B)", lineHeight: 1.6, marginBottom: 20 },
  categoryChip: {},
};
